var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('organisation-bio-cell');
import { breakpoints, theme } from '@shapeable/theme';
import { upperFirst } from 'lodash';
import { EntityBubbleImage } from './entity-bubble-image';
import { DottedChevronRightHeavyIconGlyph, LinkedinFilledIconGlyph, TwitterFilledIconGlyph } from '@shapeable/icons';
import { useEntity } from '../hooks/use-entity';
import { useLink } from '../hooks/use-link';
import { useLang } from '../hooks/use-lang';
import { useTooltipEffect } from '../hooks/use-tooltip-effect';
import { useComponentPropsFor } from '../context/component-props-context';
export var OrganisationCellPhotoSizes = {
  smallLink: 38,
  link: 60,
  banner: 120,
  bannerLarge: 180
};
export var OrganisationCellDefaultProps = {
  useTooltip: false,
  logoSize: 60,
  size: 'link',
  direction: 'row'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    ", "\n\n    ", "\n\n    ", "\n    "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    ", "\n\n    ", "\n\n    ", "\n    "])), function (_a) {
    var isClickable = _a.isClickable;
    return isClickable && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "], ["\n      &:hover {\n        filter: brightness(1.1);\n      }\n    "])));
  }, function (_a) {
    var _size = _a._size;
    return _size === 'bannerLarge' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        align-items: center;\n    "], ["\n        align-items: center;\n    "])));
  }, function (_a) {
    var _size = _a._size;
    return (_size === 'banner' || _size === 'bannerLarge') && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: 1em;\n    "], ["\n      font-size: 1em;\n    "])));
  }),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n\n     ", "\n  "], ["\n    ", "\n\n     ", "\n  "])), function (_a) {
    var _size = _a._size;
    return (_size === 'banner' || _size === 'bannerLarge') && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      font-size: ", "em;\n    "], ["\n      font-size: ", "em;\n    "])), 16 / 14);
  }, function (_a) {
    var _size = _a._size;
    return _size === 'bannerLarge' && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        align-items: flex-start;\n    "], ["\n        align-items: flex-start;\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'bannerLarge' && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        flex-direction: column;\n    "], ["\n        flex-direction: column;\n    "])));
  }, function (_a) {
    var isClickable = _a.isClickable;
    return isClickable && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  }, function (_a) {
    var direction = _a.direction;
    return direction === 'column' && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      flex-direction: column;\n      align-items: flex-start;\n    "], ["\n      flex-direction: column;\n      align-items: flex-start;\n    "])));
  }),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size,
      direction = _a.direction;
    return _size === 'bannerLarge' && direction === 'row' && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        flex-direction: row;\n    "], ["\n        flex-direction: row;\n    "])));
  })
});
var LogoStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin-right: ", ";\n    margin-bottom: ", ";\n\n  "], ["\n    margin-right: ", ";\n    margin-bottom: ", ";\n\n  "])), theme.UNIT(2), theme.UNIT(2)),
  tablet: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme.UNIT(4));
  }, function (_a) {
    var _size = _a._size;
    return _size === 'bannerLarge' && css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      margin-right: ", ";\n      margin-bottom: 0;\n    "], ["\n      margin-right: ", ";\n      margin-bottom: 0;\n    "])), theme.UNIT(8));
  })
});
var NameStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    line-height: 1.1em;\n    font-size: ", "em;\n    margin: 0 0 ", ";\n    text-decoration: none;\n    color: ", ";\n\n    ", "\n  "], ["\n    line-height: 1.1em;\n    font-size: ", "em;\n    margin: 0 0 ", ";\n    text-decoration: none;\n    color: ", ";\n\n    ", "\n  "])), 18 / 15, theme.UNIT(1), theme.COLOR('strong'), function (_a) {
    var _size = _a._size;
    return _size === 'bannerLarge' && css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      font-size: 1.3em;\n      font-weight: 400;\n    "], ["\n      font-size: 1.3em;\n      font-weight: 400;\n    "])));
  }),
  tablet: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return (_size === 'banner' || _size === 'bannerLarge') && css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      font-size: 1.5em;\n    "], ["\n      font-size: 1.5em;\n    "])));
  })
});
var PositionStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n    font-weight: 400;\n  "], ["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n    font-weight: 400;\n  "])), theme.UNIT(1), theme.COLOR('text')),
  tablet: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(2))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "], ["\n    font-size: 0.9em;\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "])), theme.UNIT(1), theme.COLOR('text')),
  tablet: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(2))
});
var SocialsStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n  "], ["\n    display: flex;\n    gap: ", ";\n  "])), theme.UNIT(2))
});
var IconStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    ", ";\n    height: 24px;\n    width: 24px;\n    margin-right: ", ";\n  "], ["\n    ", ";\n    height: 24px;\n    width: 24px;\n    margin-right: ", ";\n  "])), theme.FILL('secondary'), theme.UNIT(2))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    margin-right: ", ";\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 22px;\n    ", ";\n    color: ", ";\n    font-weight: 300;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n    \n    &:active {\n      transform: scale(.96);\n    }\n\n    ", ";\n  "], ["\n    text-transform: uppercase;\n    display: flex;\n    cursor: pointer;\n    text-decoration: none;\n    align-items: center;\n    margin-right: ", ";\n    border: 1.5px dotted ", ";\n    border-radius: 20px;\n    padding: ", " ", ";\n    font-size: ", ";\n    height: 22px;\n    ", ";\n    color: ", ";\n    font-weight: 300;\n\n    &:hover {\n      transform: scale(1.05);\n    }\n    \n    &:active {\n      transform: scale(.96);\n    }\n\n    ", ";\n  "])), theme.UNIT(2), theme.COLOR(cls.color(), 'secondary'), theme.UNIT(0), theme.UNIT(4), theme.FONT_SIZE(13), theme.FILL(cls.color(), 'secondary'), theme.COLOR(cls.color(), 'secondary'), theme.TRANSITION('transform'))
});
var ButtonIconStyles = breakpoints({
  base: css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    width: 7px;\n    margin-left: ", ";\n  "], ["\n    width: 7px;\n    margin-left: ", ";\n  "])), theme.UNIT(2))
});
var ContentStyles = breakpoints({
  base: css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (_a) {
    var direction = _a.direction;
    return direction === 'column' && css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(2));
  }, function (_a) {
    var _size = _a._size;
    return _size === 'bannerLarge' && css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin-top: ", ";\n    "], ["\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin-top: ", ";\n    "])), theme.UNIT(2));
  }),
  tablet: css(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size,
      direction = _a.direction;
    return _size === 'bannerLarge' && direction === 'row' && css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n      display: flex;\n      align-items: flex-start;\n    "], ["\n      display: flex;\n      align-items: flex-start;\n    "])));
  })
});
var FooterStyles = breakpoints({
  base: css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n    gap: ", ";\n\n  "], ["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n    gap: ", ";\n\n  "])), theme.UNIT(2), theme.UNIT(2))
});
var StatusStyles = breakpoints({
  base: css(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n    font-size: ", "em;\n    font-weight: 300;\n    line-height: 1.35em;\n    list-style: none;\n    padding: 0;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", "em;\n    font-weight: 300;\n    line-height: 1.35em;\n    list-style: none;\n    padding: 0;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), 16 / 15, theme.UNIT(1), theme.UNIT(1)),
  tablet: css(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _size = _a._size;
    return _size === 'banner' && css(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(2));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Content: styled.div.attrs(cls.attr('content'))(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Logo: styled(EntityBubbleImage)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  Name: styled.h1.attrs(cls.attr('name'))(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), NameStyles),
  Status: styled.span.attrs(cls.attr('status'))(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), StatusStyles),
  Position: styled.span.attrs(cls.attr('position'))(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  Organisation: styled.span.attrs(cls.attr('organisation'))(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Socials: styled.div(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), SocialsStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  Icon: styled(LinkedinFilledIconGlyph)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Button: styled.a.attrs(cls.attr('button'))(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  ButtonIcon: styled(DottedChevronRightHeavyIconGlyph)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), ButtonIconStyles)
};
export var OrganisationCell = function (props) {
  var _a = useComponentPropsFor('OrganisationCell', OrganisationCellDefaultProps, props),
    className = _a.className,
    children = _a.children,
    useTooltip = _a.useTooltip,
    direction = _a.direction,
    size = _a.size,
    showSocials = _a.showSocials;
  var entity = useEntity(props.entity);
  var linkedin = entity.linkedin,
    slug = entity.slug,
    name = entity.name,
    organisationStatus = entity.organisationStatus,
    url = entity.url,
    description = entity.description,
    twitter = entity.twitter,
    type = entity.type;
  var Link = useLink().Link;
  var t = useLang();
  var hasType = type && !!type.name && size === 'bannerLarge';
  var hasSocials = !!linkedin || !!twitter;
  useTooltipEffect();
  var hasBio = !!(description && description.html);
  var isClickable = !showSocials && !!(description && description.html || !!url);
  var onClick = !showSocials && !!((!hasBio || !useTooltip) && url) ? function () {
    window.open(url);
  } : function () {};
  var tooltipProps = useTooltip && hasBio ? {
    "data-event": "click",
    "data-tip": description && description.html || '',
    "data-html": true
  } : {};
  var logoSize = OrganisationCellPhotoSizes[size];
  return React.createElement(My.Container, {
    onClick: onClick,
    isClickable: isClickable,
    direction: direction,
    _size: size,
    className: cls.name(className)
  }, React.createElement(My.Body, __assign({
    isClickable: isClickable
  }, tooltipProps, {
    _size: size,
    direction: direction
  }), React.createElement(My.Logo, {
    imageStyle: "logo",
    size: logoSize,
    entity: entity,
    _size: size
  }), React.createElement(My.Content, {
    _size: size,
    direction: direction
  }, React.createElement(My.Name, {
    _size: size
  }, name), organisationStatus && organisationStatus.name && React.createElement(My.Status, {
    _size: size
  }, upperFirst(organisationStatus.name.toLowerCase())), hasType && React.createElement(My.Position, null, type.name), showSocials && React.createElement(My.Footer, {
    direction: direction
  }, hasSocials && React.createElement(My.Socials, null, linkedin && React.createElement(Link, {
    onClick: function (event) {
      event.preventDefault();
    },
    href: linkedin,
    target: "_blank"
  }, React.createElement(LinkedinFilledIconGlyph, {
    size: 25
  })), twitter && React.createElement(Link, {
    onClick: function (event) {
      event.preventDefault();
    },
    title: t('Twitter'),
    href: twitter,
    target: "_blank"
  }, React.createElement(TwitterFilledIconGlyph, {
    size: 25
  }))), url && React.createElement(My.Button, {
    target: "_blank",
    href: url
  }, t('Website'), React.createElement(My.ButtonIcon, null))))));
};
// OrganisationCell.defaultProps = OrganisationCellDefaultProps;
OrganisationCell.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51;